import React from "react";
import "./revenue.css";

export default function DrillChips({ tabs = [], value, onChange }) {
  if (!tabs.length) return null;
  return (
    <div className="drill-chips-wrap">
      <div className="drill-chips-label">Break down by:</div>
      <div className="drill-chips">
        {tabs.map(t => (
          <button
            key={t.key}
            type="button"
            className={`chip ${value === t.key ? "active" : ""}`}
            onClick={() => onChange?.(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}
